import { gql } from '@apollo/client';

export * from './contactRemove.mutation.generated';

export const CONTACT_REMOVE = gql`
  mutation contactRemove($contactId: ID!) {
    contactRemove(input: { contactId: $contactId }) {
      success
      errors
      escrow {
        id
        depositorConfigured
        beneficiaryConfigured
        agreement {
          policy {
            generate
          }
        }
      }
    }
  }
`;
